import Vue from "vue";
import Vuex from "vuex";
import introduzione from "./moduli/introduzione";
import anagrafica from "./moduli/anagfrafica";
import indirizzi from "./moduli/indirizzi";
import iscrizione from "./moduli/iscrizione";
import corsiscelti from "./moduli/corsi";
import studiprevi from "./moduli/studiprevi";
import documenti from "./moduli/documenti";
import auth from "./moduli/auth";
import dbwork from "./dbwork";
//import cambiocorsi from './moduli/cambiocorsi';
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
});

const cards_data = [
  {
    id: 1,
    testo: {
      it: "Esprimi il consenso al trattamento dei dati",
      en: "Express your consent to the processing of data",
      es: "Manifestar su consentimiento al tratamiento de datos",
    },
    titolo: {
      it: "Accettazione Norme Generali",
      en: "General Rules Acceptance",
      es: "Aceptación de Reglas Generales",
    },
    componente: "introduzione",
    icona: "privacy_tip",
  },
  {
    id: 2,
    testo: {
      it: "Inserisci i tuoi dati anagrafici",
      en: "Enter your personal data",
      es: "Introduce tus datos personales",
    },
    titolo: {
      it: "Dati Anagrafici",
      en: "Personal Data",
      es: "Información personal",
    },
    componente: "anagrafica",
    icona: "account_circle",
  },
  {
    id: 3,
    testo: {
      it: "Scegli il Ciclo di Studi a cui vuoi iscriverti",
      en: "Choose the Cycle of Studies you want to enroll in",
      es: "Elige el Ciclo de Estudio al que deseas inscribirte",
    },
    titolo: { it: "Iscrizione", en: "Enrollment", es: "Registro" },
    componente: "iscrizione",
    icona: "school",
  },
  {
    id: 4,
    testo: {
      it: "Indica gli studi previ e la conoscenza delle lingue",
      en: "Indicate your previous studies and language skills",
      es: "Indica estudios previos y conocimiento de idiomas",
    },
    titolo: {
      it: "Studi previ",
      en: "Previous studies",
      es: "Estudios previos",
    },
    componente: "studiprevi",
    icona: "book",
  },
  {
    id: 5,
    testo: {
      it: "Carica i documenti necessari",
      en: "Upload the required documents",
      es: "Sube los documentos necesarios",
    },
    titolo: { it: "Documenti", en: "Documents", es: "Documentos" },
    componente: "documenti",
    icona: "file_copy",
  },
  {
    id: 6,
    testo: {
      it: "Scegli i corsi",
      en: "Choose courses, seminars and guided readings",
      es: "Elige cursos",
    },
    titolo: { it: "Scelta Corsi", en: "Courses", es: "Elección de cursos" },
    componente: "corsi",
    icona: "menu_book",
  },
];

export default new Vuex.Store({
  modules: {
    auth,
    introduzione,
    anagrafica,
    indirizzi,
    iscrizione,
    corsiscelti,
    documenti,
    dbwork,
    studiprevi,
  },

  state: {
    statoWS: "",
    parametri: {
      prematricola: null,
      email: "",
      token: null,
      annoaccademico: null,
      semestre: null,
      statoSeminariLetture: null,
      statoDomanda: null,
      flagConfermaInvio: false,
      operatore: "",
    },
    azione: "",
    stepiscrizione: cards_data,
    StatoStep: [
      { id: 1, attivato: true, completato: false },
      { id: 2, attivato: false, completato: false },
      { id: 3, attivato: false, completato: false },
      { id: 4, attivato: false, completato: false },
      { id: 5, attivato: false, completato: false },
      { id: 6, attivato: false, completato: false },
    ],
  },

  getters: {
    isAuth: () => {
      return auth.state.isAuth;
    },
    getStatoSteps: (state, getters) => {
      return getters.checkStatoSteps;
    },
    checkStatoSteps: (state) => {
      var x = null;
      state.StatoStep.forEach((element) => (x += element.completato));
      return x;
    },
    getToken: (state) => {
      return state.parametri.token;
    },
  },

  mutations: {
    attivaStep: (state, stepid) => {
      state.StatoStep[stepid - 1].attivato = true;
    },
    disattivaStep: (state, stepid) => {
      state.StatoStep[stepid - 1].attivato = false;
    },
    StepCompleto: (state, stepid) => {
      state.StatoStep[stepid - 1].completato = true;
    },
    StepNoCommpleto: (state, stepid) => {
      state.StatoStep[stepid - 1].completato = false;
    },

    impostaParametri: (state, dati) => {
      state.parametri = dati;
    },

    avvisoWS: (state) => {
      state.statoWS = state;
    },
    resetSessione: (state) => {
      // resettiamo tutto
      // Rimuoviamo il token JWT dal localStorage
      localStorage.removeItem("jwt_token");

      state.parametri = {
        prematricola: null,
        email: "",
        token: null,
        annoaccademico: null,
        semestre: null,
        statoSeminariLetture: null,
        statoDomanda: null,
      };

      state.StatoStep = [
        { id: 1, attivato: true, completato: false },
        { id: 2, attivato: false, completato: false },
        { id: 3, attivato: false, completato: false },
        { id: 4, attivato: false, completato: false },
        { id: 5, attivato: false, completato: false },
        { id: 6, attivato: false, completato: false },
      ];

      state.introduzione = {
        consensi: {},
      };

      state.anagrafica = {
        nome: null,
        cognome: null,
        nazioneNascita: { CODICENU: null, DECODIF: null },
        comuneNascita: { CODICECOMUNE: null, DECODIF: null },
        dataNascita: null,
        linguaMadre: { CODICENU: null, DESCRIZIONE: null },
        statoCivile: { CODICENU: null, DECODIF: null },
        sesso: null,
        religione: { CODICENU: null, descrbreve: null },
        cittadinanza1: { CODICENU: null, DECODIF: null },
        cittadinanza2: { CODICENU: null, DECODIF: null },
        ordineReligioso: { CODICENU: null, DECODIF: null },
        codiceFiscale: "",
        diocesi: { CODICE: null, DIOCESI: null },
        collegio: { CODICE: null, COLLEGIO: null },
      };

      state.indirizzi = {
        residenza: {
          nazione: { CODICENU: null, DECODIF: null },
          comune: { CODICECOMUNE: null, DECODIF: null },
          cap: null,
          telefono: null,
          indirizzo: null,
        },
        recapito: {
          nazione: { CODICENU: null, DECODIF: null },
          comune: { CODICECOMUNE: null, DECODIF: null },
          cap: null,
          telefono: null,
          indirizzo: null,
          presso: null,
          cellulare: null,
        },
      };

      state.iscrizione = {
        annoaccademico: null,
        semestre: null,
        dati: {
          unita_accademica_scelta: {
            CODICENU: null,
            DECODIF: null,
          },
          fac_scelta: {
            CODICENU: null,
            DECODIF: null,
          },
          ciclo_scelto: {
            CODICENU: null,
            DECODIF: null,
          },
          spec_scelta: {
            CODICENU: null,
            DECODIFICA: null,
          },
          anno_scelto: null,
          tipoIscrizione_scelta: null,
          categoria_scelta: {
            CODICENU: null,
            DECODIF: null,
          },
          flagOspite: null,
        },
      };

      state.documenti.folder = [];

      state.corsiscelti = {
        corsi: [],
        seminari: [],
        letture: [],
        limiti: {
          corsi: { min: 0, max: 999 },
          seminari: { min: 0, max: 999 },
          letture: { min: 0, max: 999 },
        },
      };

      state.studiprevi = {
        preUniversitari: {
          titolo_studio: null,
          istituto: null,
          annoConseguimento: null,
          votazione: null,
        },
        filosofia: {
          titolo_studio: null,
          istituto: null,
          annoConseguimento: null,
          votazione: null,
        },
        teologia: {
          titolo_studio: null,
          istituto: null,
          annoConseguimento: null,
          votazione: null,
        },
        altro: {
          titolo_studio: null,
          istituto: null,
          annoConseguimento: null,
          votazione: null,
        },
        lingueAntiche: {
          latina: null,
          greca: null,
          ebraica: null,
        },
        lingueModerne: {
          francese: null,
          inglese: null,
          italiana: null,
          spagnola: null,
          tedesca: null,
        },
      };
    },

    /*restoreDati: () => {

      alert("recupero dati dal db per lo store")
    },*/
  },
  actions: {
    async restoreDatiEvent() {
      //await commit("restoreDati");
    },

    async attivaStepEvent({ commit }, stepid) {
      await commit("attivaStep", stepid);
    },
    async disattivaStepEvent({ commit }, stepid) {
      await commit("disattivaStep", stepid);
    },
    async setStepCompletoEvent({ commit }, stepid) {
      await commit("StepCompleto", stepid);
    },
    async setStepNoCompletoEvent({ commit }, stepid) {
      await commit("StepNoCommpleto", stepid);
    },
  },
  plugins: [vuexLocal.plugin],
});
